export default __webpack_public_path__ + "static/media/tour-2.9b623865.jpeg";